import { useQueryPurchasingList } from '../../models/useQueryPurchasingList'

export const useGetPurchasingListPresenter = () => {
  const { orderItems, isFetching } = useQueryPurchasingList()

  return {
    data: {
      orderItems,
    },
    states: {
      isFetching,
    },
  }
}
